import { AuthenticatedService } from "../../../../base/infrastructure";
import { IQuestionnaireGlossaryRepository, QuestionnaireGlossaryItem, QuestionnaireGlossaryChoiceItem } from "../../../domain/questionnaire";

export class QuestionnaireGlossaryRepository extends AuthenticatedService implements IQuestionnaireGlossaryRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getGlossary(): Promise<QuestionnaireGlossaryItem[]> {
    return (await this.get("api/questionnaire/glossary/get")).data;
  }

  async GetGlossaryChoiceItems(linkid: string): Promise<QuestionnaireGlossaryChoiceItem[]> {
    return (await this.get("api/questionnaire/glossary/choice-items", { params: { linkid: linkid }})).data;
  }
}
